const WEIGHT_ENUM = {
  LIGHT: 'light',
  REGULAR: 'regular',
  MEDIUM: 'medium',
  SEMI_BOLD: 'semibold',
  BOLD: 'bold',
  EXTRA_BOLD: 'extrabold',
  BLACK: 'black'
}

export default WEIGHT_ENUM
